export const credenciamento = {
    LOGINVALIDA: 'LOGINVALIDA',
    TRATAMENTO_PESQUISA: 'TRATAMENTO_PESQUISA',
    CARGOS_PESQUISA: 'CARGOS_PESQUISA',
    GET_CREDENCIAL: 'GET_CREDENCIAL',
    PESQUISA_CADASTRO: 'PESQUISA_CADASTRO',
    PESQUISA_CADASTRO_TODOS: 'PESQUISA_CADASTRO_TODOS',
    EMAIL_NOTI_CONFIRMACAO: 'EMAIL_NOTI_CONFIRMACAO',
    IMPRESSAOPDF: 'IMPRESSAOPDF',
    PESQUISA_QUANTIDADES: 'PESQUISA_QUANTIDADES',
    IMPRESSAOPDFTODOSPEDIDOS: 'IMPRESSAOPDFTODOSPEDIDOS',
    PESQUISA_CADASTRO_COM_PEDIDO: 'PESQUISA_CADASTRO_COM_PEDIDO'
}